
import { Texture, Program, Mesh } from 'ogl'
import vertex from './shaders/vertex.glsl'
import fragment from './shaders/fragment.glsl'
import gsap from 'gsap'
import { lerp } from 'Scripts/utils/utils'

export default class {
  constructor({ media, gl, geometry, scene, height, id, single, wrapper }) {
    this.media = media
    this.gl = gl
    this.geometry = geometry
    this.scene = scene
    this.galleryHeight = height
    this.extraX = 0
    this.extraY = 0
    this.transition = 0.1
    this.openSingle = false
    this.id = id
    this.single = single
    this.wrapper = wrapper

    //
    this.createTexture()
    this.createProgram()
    this.createMesh()
    this.addEventListener()
    this.onResize()

  }

  createTexture() {
    //
    this.texture = new Texture(this.gl, {
      generateMipmaps: false
    })
    //
    const image = new Image()
    image.crossOrigin = 'anonymous'
    // image.src = this.media.dataset.src
    image.src = this.media.querySelector('img').src
    image.onload = () => {
      this.texture.image = image
      // this.program.uniforms.uSize = [image.naturalWidth, image.naturalHeight]
    }

  }

  //Material
  createProgram() {

    this.program = new Program(this.gl, {
      vertex,
      fragment,
      uniforms: {
        uMap: { value: this.texture },
        uScreen: { value: [window.innerWidth, window.innerHeight] },
        uAlpha: { value: 1.0 },
        uStrength: { value: 1.0 },
        uTime: { value: 0.0 },
        uSpeed: { value: 0.0 }
      }
    })

    // console.log(this.program.uniforms)
  }

  createMesh() {
    this.mesh = new Mesh(this.gl, {
      geometry: this.geometry,
      program: this.program
    })

    this.mesh.setParent(this.scene)
  }

  setPosition() {
    this.bounds = this.media.getBoundingClientRect()
    this.updatePosition()
  }

  updatePosition() {
    this.updateScale()
    this.updateX()
    this.updateY()
  }

  updateScale() {
    this.mesh.scale.x = this.bounds.width
    this.mesh.scale.y = this.bounds.height

    this.planeOffset = this.bounds.width / 2
    this.screenOffset = window.innerWidth / 2

  }

  updateX(x = 0) {
    this.mesh.position.x = (this.bounds.width / 2) - (window.innerWidth / 2) + this.bounds.left + x + this.extraX
    this.media.style.left = (x + this.extraX) + 'px'
  }

  updateY(y = 0) {
    this.mesh.position.y = -(this.bounds.height / 2) + (window.innerHeight / 2) - this.bounds.top + y + this.extraY
  }

  onResize(gallerySize) {
    this.extraX = 0
    this.extraY = 0
    this.gallerySize = gallerySize
    this.setPosition()

  }

  update(scroll, direction) {
    this.program.uniforms.uStrength.value = ((scroll.last - scroll.current) / window.innerHeight) * 10
    this.program.uniforms.uTime.value += 0.04
    this.program.uniforms.uSpeed.value = scroll.current - scroll.last

    this.updateX(scroll.current)
    // this.updateY()

    let isAfter = this.mesh.position.x - this.planeOffset > this.screenOffset
    let isBefore = this.mesh.position.x + this.planeOffset < -this.screenOffset

    if (direction === 'right' && isAfter) {
      this.extraX -= this.gallerySize.width
      isBefore = isAfter = false

    }

    if (direction === 'left' && isBefore) {
      this.extraX += this.gallerySize.width
      isBefore = isAfter = false
    }

    // if (this.openSingle) {

    //   this.mesh.scale.x = lerp(this.mesh.scale.x, this.boundsCase.width, this.transition)
    //   this.mesh.scale.y = lerp(this.mesh.scale.y, this.boundsCase.height, this.transition)
    // }

  }

  addEventListener() {
    this.media.addEventListener('click', (e) => {
      const fullImage = this.single.querySelector('.work__img')
      this.boundsCase = fullImage.getBoundingClientRect()

      this.openSingle = true
      
      // gsap.to(this.wrapper, {
      //   autoAlpha: 1
      // }, "start")

      // gsap.to(this.single, {
      //   autoAlpha: 1,
      //   duration: 1
      // }, "start+=1")


    })
  }

}